





















































































































































/* General */
import ItemsListingLayout from '@/layouts/items-listing-layout.vue'
import moment from 'moment'

/* Mixins */
import AllLandingMixin from '@/mixins/all-landing.mixin'

/* Components */
import mailboxesImg from '@/assets/img/entities/illustration-mailbox-empty-state.png'
import mailboxesImg2x from '@/assets/img/entities/illustration-mailbox-empty-state@2x.png'
import mailboxesImg3x from '@/assets/img/entities/illustration-mailbox-empty-state@3x.png'

/* Helpers */
import LocalStore from '@/helpers/localstore'
import RouteAssistant from '@/helpers/route-assistant'
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'
import TextAssistant from '@/helpers/text-assistant'
import ItemFilterAssistant from '@/helpers/item-filter-assistant'

/* Data types */
import { EEntities, SortOptionValues } from '@/types'
import {
  IBreadcrumbItemMenuItem,
  IHomeTableItem,
} from '@/types/data-objects/items'
import { IItemTraitSet } from '@/types/data-objects/listing'
import {
  IConvosOutputAllFilterOptions,
  IConvosOutputSearchConvo,
} from '@/api/types/response.types'
import {
  IConvosInputManageCustomFilter,
  IConvosInputUpdateCustomFilter,
} from '@/api/types/request.types'

/* API */
import ConversationsAPI from '@/api/modules/convos.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'
import CustomFiltersAPI from '@/api/modules/custom-filters.api'

export default AllLandingMixin.extend({
  name: 'AllConversations',

  metaInfo: {
    title: 'All Conversations',
  },

  components: {
    ItemsListingLayout,
  },

  data() {
    return {
      isAllConvos: true,
      RouteAssistant,
      mailboxesImg,
      mailboxesImg2x,
      mailboxesImg3x,

      showMergeConvosModal: false,
    }
  },

  beforeDestroy() {
    this.endPolling()
  },

  async created() {
    this.isLoadingInitialData = true
    await Promise.all([this.fetchFilterOptions()])
    LocalStore.lastItemListRouteVisited = RouteAssistant.getAllConversationsRoute(
      this.accountID,
    )
    this.startPolling()
    this.postCreated()
    this.isLoadingInitialData = false
  },

  methods: {
    startPolling() {
      // Ensure we're clearing old polling, if necessary
      this.endPolling()
      this.poller = setInterval(async () => {
        try {
          await this.autoRefreshDataIfStale()
        } catch {
          this.endPolling()
        }
      }, this.pollIntervalInMS)
    },
    endPolling() {
      clearInterval(this.poller)
    },
    async reloadData() {
      await Promise.all([this.fetchFilterOptions(), this.fetchResults(false)])
    },
    async autoRefreshDataIfStale() {
      const lastUpdatedEpochTime = await MailboxesAPI.get_MostRecentLastUpdatedEpochTime()
      if (
        lastUpdatedEpochTime.epochTime &&
        this.lastAccessEpochTime < lastUpdatedEpochTime.epochTime
      ) {
        await Promise.all([this.fetchFilterOptions(), this.fetchResults(false)])
        this.lastAccessEpochTime = lastUpdatedEpochTime.epochTime
      }
    },
    async fetchResults(showResultsLoading: boolean = true) {
      this.selectedItemIDs = []
      this.isLoadingResults = showResultsLoading
      const params = {
        page: this.currentPage,
        mailbox_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.mailboxIDs,
        ),
        priority_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.priorityIDs,
        ),
        status_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.statusIDs,
        ),
        status_type: this.itemTraitSet.statusType,
        assignee_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.assigneeIDs,
        ),
        assigned_not_to_you: this.itemTraitSet.assignedNotToYou,
        job_appointee_groupings_string: this.itemTraitSet
          .jobAppointeeGroupingsString,
        including_tag_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.includingTagIDs,
        ),
        not_including_tag_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.notIncludingTagIDs,
        ),
        start_due_date: this.itemTraitSet.startDueDate,
        end_due_date: this.itemTraitSet.endDueDate,
        due_type: this.itemTraitSet.dueType,
        sort: this.itemTraitSet.sort,
        search_term: this.itemTraitSet.searchTerm,
        only_watching: this.itemTraitSet.onlyWatching,
        created_within_days: this.itemTraitSet.createdWithinDays,
        last_updated_within_days: this.itemTraitSet.lastUpdatedWithinDays,
        customer_ids: TextAssistant.convertNumberArrayToStringList(
          this.itemTraitSet.customerIDs,
        ),
        is_spam: this.itemTraitSet.isSpam,
      }

      try {
        // If hiding the load, don't reset total item count so there
        // is no "pulse" on the dashboard filter picker
        if (showResultsLoading) {
          this.totalItemCount = null
        }
        // @ts-ignore
        const response = await ConversationsAPI.get_Search(
          params.page,
          params.mailbox_ids,
          params.customer_ids,
          params.sort,
          params.is_spam,
          params.priority_ids,
          params.status_ids,
          params.status_type,
          params.assignee_ids,
          params.assigned_not_to_you,
          params.job_appointee_groupings_string,
          params.including_tag_ids,
          params.not_including_tag_ids,
          params.due_type,
          params.start_due_date,
          params.end_due_date,
          params.search_term,
          params.only_watching,
          params.created_within_days,
          params.last_updated_within_days,
        )

        // Store access epoch time
        this.lastAccessEpochTime = response.accessEpochTime

        // Pagination
        this.totalItemCount = response.totalConversationCount

        // Results
        // @ts-ignore
        this.results = response.listConversations.map(item =>
          this.mapResultsToTableFormat(item),
        )

        const breadCrumbItems = [] as IBreadcrumbItemMenuItem[]

        response.listConversations.forEach(t => {
          breadCrumbItems.push({
            itemID: t.id,
            entityID: t.mailbox.id,
            entityName: t.mailbox.name,
            entityType: EEntities.MAILBOXES,
            title: t.title,
            refNumber: t.refNumber,
          } as IBreadcrumbItemMenuItem)
        })

        BreadcrumbAssistant.cacheBreadcrumbItemMenuItems(
          this.$store,
          breadCrumbItems,
        )
      } catch (error) {
        LocalStore.clearAllConvosSavedQuery(this.accountID)
        this.$confirm(
          `Let's reset your mailbox filters so you can try again.`,
          {
            dangerouslyUseHTMLString: true,
            center: true,
            type: 'warning',
            title: 'This filter is no longer available',
          },
        ).then(() => {
          this.itemTraitSet.mailboxIDs = []
        })
      }
      this.isLoadingResults = false
    },

    async fetchFilterOptions() {
      try {
        const response = await ConversationsAPI.get_All_FilterOptions()
        this.hydrateFilterOptions(response)
      } catch (error) {
        this.$error.emit(error)
      }
    },

    hydrateFilterOptions(data: IConvosOutputAllFilterOptions) {
      this.hydrateFilterOptionsForListing_Base(data)
      this.entities = data.listMailboxes

      this.customFilterNavItems = data.listCustomFilters.map(c => ({
        value: ItemFilterAssistant.getCustomFilterIdentifier(c.id),
        label: c.name,
        icon: 'filter',
      }))
      this.customFilterItemTraitSets = data.listCustomFilters.map(c => ({
        id: c.id,
        itemTraitSet: {
          priorityIDs: c.listPriorityIDs ? c.listPriorityIDs : [],
          statusIDs: c.listStatusIDs ? c.listStatusIDs : [],
          statusType: c.statusType ? c.statusType : '',
          assigneeIDs: c.listAssigneeIDs ? c.listAssigneeIDs : [],
          assignedNotToYou: c.assignedNotToYou,
          jobAppointeeGroupingsString: ItemFilterAssistant.convertJobAppointeeGroupingsToStringRepresentation(
            c.listJobAppointeeGroupings,
          ),
          dueType: c.dueType ? c.dueType : null,
          includingTagIDs: c.listIncludingTagIDs ? c.listIncludingTagIDs : [],
          notIncludingTagIDs: c.listNotIncludingTagIDs
            ? c.listNotIncludingTagIDs
            : [],
          startDueDate: c.startDueDate
            ? moment(c.startDueDate).format('YYYY-MM-DD')
            : null,
          endDueDate: c.endDueDate
            ? moment(c.endDueDate).format('YYYY-MM-DD')
            : null,
          searchTerm: c.searchTerm ? c.searchTerm : '',
          onlyWatching: c.onlyWatching,
          createdWithinDays: c.createdWithinDays,
          lastUpdatedWithinDays: c.lastUpdatedWithinDays,
          creatorIDs: [], // Never used, default it so the comparison is equal in isItemTraitSetEquivalent()
          customerIDs: c.listCustomerIDs ? c.listCustomerIDs : [],
          isSpam: c.isSpam,
          sort: SortOptionValues.UPDATED_RECENT,
          projectIDs: [], // Unused, default it so the comparison is equal in isItemTraitSetEquivalent()
          mailboxIDs: c.listMailboxIDs ? c.listMailboxIDs : [],
        } as IItemTraitSet,
      }))
    },

    async createCustomFilter(name: string) {
      try {
        this.isCustomFilterSubmitting = true
        const formData = {
          name,
          listCustomerIDs: this.itemTraitSet.customerIDs,
          listAssigneeIDs: this.itemTraitSet.assigneeIDs,
          listJobAppointeeGroupings: ItemFilterAssistant.convertStringToJobAppointeeGroupingsRepresentation(
            this.itemTraitSet.jobAppointeeGroupingsString,
          ),
          listIncludingTagIDs: this.itemTraitSet.includingTagIDs,
          listNotIncludingTagIDs: this.itemTraitSet.notIncludingTagIDs,
          listStatusIDs: this.itemTraitSet.statusIDs,
          listPriorityIDs: this.itemTraitSet.priorityIDs,
          listMailboxIDs: this.itemTraitSet.mailboxIDs,
          createdWithinDays: this.itemTraitSet.createdWithinDays,
          lastUpdatedWithinDays: this.itemTraitSet.lastUpdatedWithinDays,
          assignedNotToYou: this.itemTraitSet.assignedNotToYou,
          statusType: this.itemTraitSet.statusType,
          dueType: this.itemTraitSet.dueType,
          startDueDate: this.itemTraitSet.startDueDate,
          endDueDate: this.itemTraitSet.endDueDate,
          searchTerm: this.itemTraitSet.searchTerm,
          isSpam: this.itemTraitSet.isSpam,
          onlyWatching: this.itemTraitSet.onlyWatching,
        } as IConvosInputManageCustomFilter
        const response = await ConversationsAPI.post_CreateCustomFilter(
          formData,
        )
        await this.fetchFilterOptions()
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isCustomFilterSubmitting = false
      }
    },

    async updateCustomFilter(name: string) {
      try {
        this.isCustomFilterSubmitting = true
        const formData = {
          name,
          listCustomerIDs: this.itemTraitSet.customerIDs,
          listAssigneeIDs: this.itemTraitSet.assigneeIDs,
          listJobAppointeeGroupings: ItemFilterAssistant.convertStringToJobAppointeeGroupingsRepresentation(
            this.itemTraitSet.jobAppointeeGroupingsString,
          ),
          listIncludingTagIDs: this.itemTraitSet.includingTagIDs,
          listNotIncludingTagIDs: this.itemTraitSet.notIncludingTagIDs,
          listStatusIDs: this.itemTraitSet.statusIDs,
          listPriorityIDs: this.itemTraitSet.priorityIDs,
          listMailboxIDs: this.itemTraitSet.mailboxIDs,
          createdWithinDays: this.itemTraitSet.createdWithinDays,
          lastUpdatedWithinDays: this.itemTraitSet.lastUpdatedWithinDays,
          assignedNotToYou: this.itemTraitSet.assignedNotToYou,
          statusType: this.itemTraitSet.statusType,
          dueType: this.itemTraitSet.dueType,
          startDueDate: this.itemTraitSet.startDueDate,
          endDueDate: this.itemTraitSet.endDueDate,
          searchTerm: this.itemTraitSet.searchTerm,
          isSpam: this.itemTraitSet.isSpam,
          onlyWatching: this.itemTraitSet.onlyWatching,
        } as IConvosInputUpdateCustomFilter
        const response = await ConversationsAPI.put_UpdateCustomFilter(
          ItemFilterAssistant.getIDOfFilterIdentifier(
            this.currentFilterNavItem.value,
          ),
          formData,
        )
        await this.fetchFilterOptions()
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isCustomFilterSubmitting = false
      }
    },

    handleDeleteCustomFilter(identifier: string) {
      this.$confirm(
        `<strong>This cannot be undone.</strong>
        <br>Are you sure you want to delete this?`,
        {
          dangerouslyUseHTMLString: true,
          center: true,
          confirmButtonText: 'Yes, Delete',
          confirmButtonClass: 'el-button--strawberry',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'el-button--text',
          type: 'warning',
          title: 'Delete this custom filter?',
        },
      ).then(() => {
        this.deleteCustomFilter(identifier)
      })
    },

    async deleteCustomFilter(identifier: string) {
      try {
        const response = await CustomFiltersAPI.delete_Delete(
          ItemFilterAssistant.getIDOfFilterIdentifier(identifier),
        )

        this.fetchFilterOptions()

        if (this.currentFilterNavItem.value !== identifier) {
          this.$messaging.showSuccess(response.message)
        }
      } catch (error) {
        this.$error.emit(error, true)
      }
    },

    mapResultsToTableFormat(item: IConvosOutputSearchConvo): IHomeTableItem {
      return {
        ...item,
        parent: item.mailbox,
        entityType: EEntities.MAILBOXES,
      }
    },
  },
})
